var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M57,10.9H7c-3.2,0-5.8,2.6-5.8,5.8v30.7c0,3.2,2.6,5.8,5.8,5.8h50c3.2,0,5.8-2.6,5.8-5.8V16.7C62.8,13.5,60.2,10.9,57,10.9z M57,14.4c0.5,0,0.9,0.1,1.3,0.4L33.4,29.9c-0.9,0.5-1.9,0.5-2.8,0L5.7,14.8c0.4-0.2,0.8-0.4,1.3-0.4H57z M57,49.6H7\tc-1.2,0-2.3-1-2.3-2.3v-29l24,14.6c1,0.6,2.1,0.9,3.2,0.9c1.1,0,2.2-0.3,3.2-0.9l24-14.6v29C59.3,48.6,58.2,49.6,57,49.6z"}));
}

Envelope.defaultProps = {"version":"1.1","viewBox":"0 0 64 64","x":"0","y":"0","xmlSpace":"preserve"};

module.exports = Envelope;

Envelope.default = Envelope;
